<template>
<div>

<div class="quiz_progress mb-4">

<div  class="quiz_progress_home_item"
v-tooltip.bottom="{ value: $store.state.languages.lang_phrases.baslangic_sayfasina_don, disabled: false,class: 'custom-top-tooltip' }"
>
<div class="quiz_progress_item_inner animate_class"  @click="gotoHome()">
<i class="pi pi-home"></i>
</div>
</div>

<div  class="quiz_progress_home_item"
v-tooltip.bottom="{ value: $store.state.languages.lang_phrases.ana_listeye_don, disabled: false,class: 'custom-top-tooltip' }"
>
<div class="quiz_progress_item_inner animate_class"  @click="gotoList()">
<i class="pi pi-list"></i>
</div> 
</div>


<FlowProcess></FlowProcess>

</div>

<template v-if="video_ready">

<template v-if="video">
<h4 class="text-primary mt-1 ml-2" >{{videoname}}</h4>	
</template>

<div class="video_wrap">
<VideoPlayer :options="videoOptions" @durationChanged="durationChanged" @playEnded="playEnded" :userprogress="theproggress" :keepproggresstrack="true" :key="video.filepath"/>
<div class="videomask" :style="maskstyle" v-show="mask.display">
	

<h2 class="text-white" id="countdown-number" v-text="mask.progress"></h2>
<div id="countdown" @click="stopInterval">
  <span class="material-icons-outlined md-36  text-white coundown_icon">
    pause_circle
    </span>
  <svg>
    <circle r="46" cx="50" cy="50" :style="'animation-play-state:'+mask.animation_play_state"></circle>
  </svg>
</div>
<h1 class="text-white p-link mt-4" @click="gotoNextVideo">{{$store.state.languages.lang_phrases.sonraki_video}}</h1>
</div>


</div>
</template>





</div>	
</template>

<script>

//import 'video.js/dist/video-js.css'
export default {

  name: 'EvaluationEducationVideo',
  data () {
    return {
    	video_ready:false,
    	mask:{
    		theproggress:0,
    		display:false,
    		height:0,
    		width:0,
    		progress:10,
    		progressinterval:null,
    		countdownNumberEl:null,
    		animation_play_state:'running'
    	},
    	maskstyle:null,
    	video:null,
    	videoOptions: {
	        autoplay: false,
	        fluid:true,
	        volume:0.2,
	        aspectRatio: '32:13',
	        controls: true,
	        sources: [
	          {
	            src:null,
	            type: 'video/mp4'
	          }
	        ]
      },
    }
  },
  mounted()
  {  	
  	this.calculateEducationProgress("first_init")
  	this.sortVideo()
  	addEventListener('resize', (event) => {
  		this.adjustMaskStyle()
  	});
  },
  computed: {  
  	apihook()
  	{
  		//return "https://api.verifyhub.io/"
  		
  		let api =  process.env.VUE_APP_API_HOOK
  		api = api.replace("/api/","/")
  		//return api
  		return "https://storage.googleapis.com/verifycloud/"
  	},
  	userlang()
  	{
  		return this.$store.state.auth.user.preflang_id
  	},
  	videoname()
  	{
  		return this.getTheTranslation(this.video,"translation")
  		if(this.video.translations && this.video.translations.length)
  		{
  			let translation = this.video.translations.find((item)=>{return item.language_id == this.$store.state.auth.user.preflang_id})
  			if(translation)
  			{
  				return translation.translation
  			}
  			else
  			{
  				return ""
  			}
  		}
  		else
		{
			return ""
		}
  		
  	},
  	videodescription()
  	{

  	},
    player() {
      return this.$refs.videoPlayer.player;
    },
  },
  watch:{
  	async userlang(newval)
  	{
  		console.log("userlang")
  		this.video = await this.getVideoFilePath()
  		console.log(this.video.filepath)
  		this.$store.dispatch('evaluation/setActiveVideo',this.video) 
  		this.videoOptions.sources[0].src = this.video.filepath+"#t="+this.theproggress
  	},
  },
  umounted()
  {
  	this.video =  null
  },
  methods:{  
  	async getTheProcess()
  	{
	  		if(this.$store.state.evaluation.active_video)
	    	{
	    		if(this.$store.state.evaluation.active_video.progresses.length)
	    		{
	    			this.theproggress = this.$store.state.evaluation.active_video.progresses[0].progress
	    		}
	    		else
	    		{
	    			this.theproggress = 0
	    		}
	    		
	    	}
	    	else
				{
					this.theproggress = 0
				}
  	},
  	async getVideoFilePath()
  	{
  		let videos = this.sanitizeArray(this.$store.state.evaluation.flow_videos.videos)
			let the_video = videos.find((item)=>{return item.id == this.$route.params.video_id})		
			let video_path
			if(the_video.translations.length)
			{
				let preflang_id = this.$store.state.auth.user.preflang_id
				let translation =  the_video.translations.find((item)=>{return item.language_id == preflang_id})
				if(translation && translation.filepath)
				{
					video_path = translation.filepath
				}
				else
				{
					video_path = the_video.filepath
				}
			}
			else
			{
				video_path = the_video.filepath
			}
		  video_path =  this.apihook+video_path
		  the_video.filepath = video_path
		  let video_test = await this.getVideoUrl(the_video.id)
		  console.log("video_test")
		  console.log(video_test)
		  console.log(the_video)
		  console.log(the_video.filepath)

			return await the_video
  	},
  	async getVideoUrl(id)
  	{	
  		let data = await this.generalApiGet("serve_video_file/"+id)
  		return data
  	},	
  	durationChanged(data)
  	{
  		this.theproggress = parseInt(data)
  		this.$socket.emit('video_progress_changed', { 
													progress:parseInt(data),
													video_id:parseInt(this.$route.params.video_id),
													flowsupplier_id:this.$store.state.evaluation.evaluation.id 
													})
  	},
  	playEnded()
  	{
  		console.log(this.$store.state.evaluation.flow_videos.videos)
  		console.log(this.video)
  		let vid_ind = this.$store.state.evaluation.flow_videos.videos.findIndex(item=>item.id == this.video.id)
  		console.log(vid_ind)
  		this.$socket.emit('video_progress_ended', { 													
													video_id:parseInt(this.$route.params.video_id),
													flowsupplier_id:this.$store.state.evaluation.evaluation.id 
													})
  		if(vid_ind==this.$store.state.evaluation.flow_videos.videos.length-1)
  		{
  			this.gotoNextVideo()
  		}
  		else
  		{
	  		this.mask.display = true
	  		this.runInterval()
  		}
  		
  	},
  	handleMounted(payload)
  	{
  		//console.log("payload")
  		//console.log(payload)
  	},
	async sortVideo()
	{
		this.video_ready = await false
		let videos_progress_data = await this.generalApiGet("audit/get_education_pack_progress/"+this.$route.params.id)
		
		let flow_process = await this.$store.state.evaluation.flow_process
		flow_process.progress_percentage = await videos_progress_data
		await this.$store.dispatch('evaluation/setFlowProcess',flow_process)
		this.video = await null

		
	  	
  	//this.video.filepath = await this.getVideoUrl()
  	//this.video.filepath = await "https://oasis40.com/short.mp4"
  	this.video = await this.getVideoFilePath()

  	await console.log(this.theproggress)
  	await this.$store.dispatch('evaluation/setActiveVideo',this.video) 
  	await this.getTheProcess()
  	console.log("theproggress")
  	console.log(this.video)
  	if(this.video.progresses.length && this.video.progresses[0].status=="ended")
  	{
  		this.videoOptions.sources[0].src = this.video.filepath
  	}
  	else
  	{
  		this.videoOptions.sources[0].src = this.video.filepath+"#t="+this.theproggress
  	}
  	
	  	
	  	
	  			 
  	this.video_ready = await true 
  	await setTimeout(()=>{
  		this.adjustMaskStyle()
  	})
	  	 
	  	
	  	

	},
	adjustMaskStyle()
	{
		let video_player_wrapper =  document.getElementById("video_player_wrapper");
  		 if(video_player_wrapper)
  		 {
  		 	this.mask.height =  video_player_wrapper.offsetHeight+"px"
  			this.mask.width =  video_player_wrapper.offsetWidth+"px"
  			this.maskstyle =  "height:"+this.mask.height+";width:"+this.mask.width
  			this.display = true
	  			
  		 }
	  		
	},
	runInterval()
	{
		
		
		this.mask.progressinterval = setInterval(()=>{
					this.mask.progress--
	  				if(this.mask.progress == 0)
	  				{
	  					clearInterval(this.mask.progressinterval);
	  					this.gotoNextVideo()
	  					
	  				}
	  			
	  		},1000)
	},
	stopInterval()
	{
		clearInterval(this.mask.progressinterval);
		this.mask.animation_play_state = 'paused'
	},
	async gotoNextVideo()
	{
		clearInterval(this.mask.progressinterval);
		let nextvideoind = this.$store.state.evaluation.flow_videos.videos.findIndex((item)=>{return item.id ==  this.$route.params.video_id})
		
		
		if(nextvideoind !== this.$store.state.evaluation.flow_videos.videos.length-1)
		{
			//this.calculateEducationProgress("next_video")

			this.$router.push({ name: 'EvaluationEducationVideo', params: { video_id:this.$store.state.evaluation.flow_videos.videos[nextvideoind+1].id } })
		}
		else
		{
			//this.gotoList()
			let projectsupplier = await this.silentApiGet("audit/get_project_supplier_id/"+this.$store.state.evaluation.evaluation.uuid)  

      //return false
      await this.$router.push({ name: 'SupplierBrandProject',params:{project_id:projectsupplier.uuid,supplier_uuid:projectsupplier.supplier.uuid} })
		}
	},
     async gotoHome()
    {
    	console.log("gotohome")
    	let userroles = await this.$store.state.auth.user.userroles
      let roletype = "admin"
      for(let i=0; i<userroles.length;i++)
      {
        if(userroles[i].name=="supplier")
        {
          roletype = "supplier"
          break;
        }
       
      }
      this.return_home_loader = await true
      //console.log(this.$store.state.evaluation.evaluation)
      let projectsupplier = await this.silentApiGet("audit/get_project_supplier_id/"+this.$store.state.evaluation.evaluation.uuid)
      await console.log(projectsupplier)
      this.return_home_loader = await true
      //return false
      if(roletype=="supplier")
      {
        await this.$router.push({ name: 'SupplierBrandFlowSummary',params:{supplier_uuid:projectsupplier.supplier.uuid,project_id:projectsupplier.uuid,flow_id:this.$store.state.evaluation.evaluation.uuid} })
      }
      else
      {
        await this.$router.push({ name: 'SupplierProjectFlowSummary',params:{id:projectsupplier.supplier_id,project_id:projectsupplier.uuid,flow_id:this.$store.state.evaluation.evaluation.uuid} })
      }
      //return false
      //await this.$router.push({ name: 'SupplierBrandProject',params:{supplier_uuid:projectsupplier.supplier.uuid,project_id:projectsupplier.uuid} })
    },
    gotoList()
    {
      this.$router.push({ name: 'EvaluationEducation' })
    },
  },
}
</script>

<style lang="css" scoped>
</style>